export default {
  enums: [
    { id: 'CONTROL_SAMPLES' },
    { id: 'ARCHIVAL_SAMPLES' },
    { id: 'CONFIRMATION_COMPLIANCE' },
  ]
};
